import React from 'react';
import { Spin } from 'antd';
import { consumeModule } from '@didi/nebula/consume';

export const FallbackComp = <Spin />;

export const FallbackErrorComp = ({ error }: { error: Error }) => (
  <div style={{ padding: 24 }}>
    <h1>加载远程模块失败</h1>
    <p>{error.message}</p>
    <button type="button" onClick={() => window.location.reload()}>
      重试
    </button>
  </div>
);

type RemoteAppProps = {
  /** 如 `direct/App`、`devops/App` */
  moduleId: string;
  basename?: string;
  isSubApp?: boolean;
};

/** moduleId → bridge 组件，模块级只创建一次，避免 Host 重渲染导致 remote remount */
const remoteAppCache = new Map<string, ReturnType<typeof consumeModule>>();

/**
 * 消费 Nebula MF 远程子应用（远程侧用 exposeModule）
 * 对齐 `@didi/nebula/consume` 的 consumeModule 用法
 */
export function getRemoteApp(moduleId: string) {
  let Comp = remoteAppCache.get(moduleId);
  if (!Comp) {
    Comp = consumeModule(moduleId, {
      loading: FallbackComp,
      fallback: FallbackErrorComp,
    });
    remoteAppCache.set(moduleId, Comp);
  }
  return Comp;
}

export function RemoteApp({ moduleId, basename, isSubApp, ...rest }: RemoteAppProps) {
  const Comp = getRemoteApp(moduleId);
  return <Comp basename={basename} isSubApp={isSubApp} {...rest} />;
}

export default RemoteApp;
